// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".relation-btn[data-v-1dd338ac] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.relation-btn__descr[data-v-1dd338ac] {\n  -ms-flex-item-align: center;\n      align-self: center;\n  min-width: 135px;\n  padding-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
